import { Types } from '~/graphql';
import { formatTranslation } from './formatTranslation';

export const formatParticipantTypeName = (
    participantType: Types.ParticipantTypeR,
    locale: Locale
) =>
    formatTranslation(participantType?.name, { locale }) ||
    participantType.name[0]?.value ||
    participantType.code;
